<template>
  <div :id="id_header">
    <header id="sidebar-header-container">
      <span @click.prevent="_fullWidthAssociateComponent()"
        class="material-icons material-icons-outlined full-width" style="margin-left: 7px;">multiple_stop</span>
      <h2 class="typo-headline-6">{{ title_header }}</h2>
      <span @click.prevent="closeComponent()" class="material-icons material-icons-outlined" style="margin-right: 7px;">close</span>
    </header>
  </div>
</template>



<script>
import { mapMutations, mapGetters } from "vuex";
export default {
  name: 'HeaderSidebarRight',
  props: {
    id_header: { type: String },
    title_header: { type: String }
  },

  data() {
    return {
      is_fullscreen: false,
    };
  },

  computed: {
    ...mapGetters(["_g_Active_right_component"])
  },

  watch: {
    _g_Active_right_component() { this.is_fullscreen = false; },
  },

  methods: {
    ...mapMutations(['setActiveRightComponent']),

    closeComponent: function () {
      this.is_fullscreen = false;
      this.setActiveRightComponent('');
    },

    removeSelectedClass: function () {
      const menu_secundario_container = document.getElementById('stockchart-menu-secundario');

      if (menu_secundario_container !== null) {
        const comp_list_container = menu_secundario_container.querySelector('ul');

        if (comp_list_container !== null) {
          const component_buttons = comp_list_container.querySelectorAll('li');

          for (let i = 0; i < component_buttons.length; i++) {
            component_buttons[i].classList.remove('eurekers-parent-menu-active');
          }
        }
      }
    },


    _fullWidthAssociateComponent() {
      const panel = document.getElementById('sidebar-content');
      if (!panel) return;
      this.is_fullscreen = !this.is_fullscreen;
      panel.dataset.expanded = String(this.is_fullscreen);
      window.dispatchEvent(new Event('legacy-panel-resize'));
    },
  },
}
</script>



<style lang="scss" scoped>
#sidebar-header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 15px;
  padding-bottom: 15px;
}

#sidebar-header-container>* {
  position: relative !important;
  left: unset !important;
  top: unset !important;
}
</style>
